import { Label } from 'components/form/form.style'
import { ColorPicker as PrimeColorPicker } from 'primereact/colorpicker'
import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

interface ColorPickerProps {
    name: string
    control: Control<any>
    errors: FieldErrors<any>
    label: string
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ name, control, errors, label }) => {
    const errorMessage = errors[name]?.message as any

    return (
        <div className="p-field">
            <Label htmlFor={name}>{label}</Label>
            <Controller
                name={name}
                control={control}
                defaultValue="ba9d31"
                render={({ field }) => (
                    <div>
                        <PrimeColorPicker
                            id={name}
                            {...field}
                            defaultColor="ba9d31"
                            onChange={(e) => field.onChange(e.value)}
                            style={{ width: '30px', borderRadius: '6px', marginTop: '10px' }}
                        />
                    </div>
                )}
            />
            {errorMessage && <small className="p-error">{errorMessage}</small>}
        </div>
    )
}
